exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-sidenav-header {\n  padding: 20px;\n  background-color: #f5f5f5; }\n  .md-sidenav-header img {\n    margin-bottom: 16px; }\n\n.md-sidenav-header2 {\n  background-color: #f5f5f5; }\n\nmd-sidenav-container,\n.mat-sidenav-content {\n  min-height: 100%; }\n\nmd-sidenav {\n  width: 260px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: rgba(0, 0, 0, 0.12); }\n\n.toolbaricon {\n  padding: 4px 20px 4px 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/navigation/navigation.component.scss
// module id = ../../../../../src/app/components/navigation/navigation.component.scss
// module chunks = main